import IcTableIcon from './IcTableIcon'

export default IcTableIcon
